export default {
  title: '安全中心',

  accountSec: '账号安全',
  loginPwd: '登录密码',
  loginPwdDesc: '已设置 · 建议定期更换',
  loginPwdAction: '修改 ›',

  fundPwd: '资金密码',
  fundPwdUnset: '未设置 · VIPPAY 支付前须设置',
  fundPwdSet: '已设置 · 提现等敏感操作需验证',
  fundPwdSetup: '设置 ›',
  fundPwdChange: '修改 ›',

  bindPhone: '绑定手机',
  bindPhoneUnset: '未绑定 · 用于验证码与找回',
  bindPhoneAction: '绑定 ›',
  bindPhoneChange: '更换 ›',

  bindEmail: '绑定邮箱',
  bindEmailUnset: '未绑定 · 用于安全通知与找回',
  bindEmailAction: '绑定 ›',
  bindEmailChange: '更换 ›',

  devices: '登录设备',
  deviceCurrent: '本机 · 当前在线',
  deviceLocal: '本机',
  deviceEmpty: '暂无登录设备',
  deviceLoading: '加载中…',
  kick: '下线',
  kickOk: '设备已下线',

  logs: '安全记录',
  logEmpty: '暂无安全记录',
  logLoading: '加载中…',
  logOk: '正常',
  logBlocked: '拦截',
  logUnknown: '安全事件',
  logLocalAction: '本机操作',
  logPwdReset: '重置登录密码',
  logReason: {
    bad_password: '密码错误',
    bad_code: '验证码错误',
    bad_old_password: '原密码错误',
    player_disabled: '账号已禁用',
    login_restricted: '登录受限',
    fund_password_mismatch: '资金密码错误',
    fund_password_locked: '资金密码已锁定',
  },
  logLoginOk: '登录成功',
  logLoginFail: '登录失败',
  logNewDevice: '新设备登录',
  logWithdrawSubmit: '提现申请提交',
  logPhoneBound: '绑定手机',
  logPhoneChanged: '更换绑定手机',
  logPwdChanged: '修改登录密码',
  logFundSet: '设置资金密码',
  logFundChanged: '修改资金密码',
  logFundReset: '重置资金密码',
  logFundVerifyFail: '资金密码验证失败',
  logEmailBound: '绑定邮箱',
  logEmailChanged: '更换绑定邮箱',
  logDeviceKick: '远程设备已下线',

  changeLoginPwd: '修改登录密码',
  currentPwd: '当前密码',
  currentPwdPh: '请输入当前密码',
  newPwd: '新密码',
  newPwdPh: '8-64 位,含字母与数字',
  confirmNewPwd: '确认新密码',
  confirmNewPwdPh: '再次输入新密码',
  confirmChange: '确认修改',
  pwdHint: '修改成功后,其他已登录设备将自动下线',
  pwdOk: '密码已修改,其他设备已自动下线',
  errPwdOldEmpty: '请输入当前密码',
  errPwdRule: '新密码须为 8-64 位且包含字母与数字',
  errPwdMismatch: '两次输入的新密码不一致',
  errPwdSame: '新密码不能与当前密码相同',

  setFundPwd: '设置资金密码',
  changeFundPwd: '修改资金密码',
  resetFundPwd: '重置资金密码',
  currentFundPwd: '当前资金密码',
  newFundPwd: '新资金密码',
  confirmFundPwd: '确认新资金密码',
  fundPwdPh: '6 位数字',
  fundPwdPhHint: '6 位数字,勿与生日/手机号相同',
  fundPwdAgain: '再次输入',
  forgetFund: '忘记资金密码?›',
  confirm: '确认',
  fundHint: '资金密码用于提现、账户变更等敏感操作;连续输错 5 次将锁定 2 小时。',
  fundOkSet: '资金密码已设置',
  fundOkChange: '资金密码已修改',
  fundOkReset: '资金密码已重置',
  errFundFormat: '请输入 6 位数字资金密码',
  errFundOld: '当前资金密码不正确',
  errFundSame: '新密码不能与当前资金密码相同',
  errFundMismatch: '两次资金密码不一致',
  viaPhone: '📱 手机短信',
  viaEmail: '✉️ 邮箱验证',
  verifyPhone: '验证绑定手机',
  verifyEmail: '验证绑定邮箱',
  otp: '验证码',
  otpPh: '6 位验证码',
  sendOtp: '获取验证码',
  otpSent: '验证码已发送',
  otpCd: '{n}s',
  otpWait: '{n}s 后重发',
  errOtp: '请输入正确的验证码',
  fundNoBind:
    '⚠️ 你尚未绑定手机或邮箱,无法自助重置资金密码。请先在「账号安全」绑定手机或邮箱,或联系在线客服人工核身。',

  changePhone: '更换绑定手机',
  bindPhoneTitle: '绑定手机',
  stepVerifyPhone: '1 验证当前手机',
  stepBindPhone: '2 绑定新手机',
  curPhone: '当前绑定手机',
  smsOtp: '短信验证码',
  smsOtpCurPh: '发送至当前手机',
  smsOtpNewPh: '发送至新手机',
  next: '下一步',
  newPhone: '新手机号',
  newPhonePh: '请输入手机号',
  confirmBind: '确认更换',
  confirmBindFirst: '确认绑定',
  phoneHint1:
    '为保障账户安全,更换手机须先验证当前手机;当前手机无法接收短信请联系在线客服人工核身。',
  phoneHint2: '更换成功后,验证码、安全通知将发送至新手机。',
  phoneOk: '手机号已更新',
  errPhone: '请输入正确的手机号',
  errPhoneSame: '新手机号不得与当前相同',

  bindEmailTitle: '绑定邮箱',
  changeEmail: '更换绑定邮箱',
  stepVerifyEmail: '1 验证当前邮箱',
  stepBindEmail: '2 绑定新邮箱',
  curEmail: '当前绑定邮箱',
  emailOtp: '邮箱验证码',
  emailOtpCurPh: '发送至当前邮箱',
  emailAddr: '邮箱地址',
  newEmailAddr: '新邮箱地址',
  emailPh: "name{'@'}example.com",
  emailHint1: '当前邮箱无法接收邮件?请联系在线客服人工核身。',
  emailHint2: '绑定后用于安全通知、账户找回;可随时在此更换。',
  emailOk: '邮箱已更新',
  errEmail: '请输入有效邮箱',
  errEmailSame: '新邮箱不得与当前相同',
}
